/**
 * Registers `public/sw.js`, which makes the installed dashboard launch instantly and fall back to
 * the cached app shell when offline. Production only: in development it would cache Vite's
 * unbundled modules and hide changes.
 */
export function registerServiceWorker() {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    // Subscribe pages are also served on the marketing origin, which has no `/sw.js`; failing there is fine.
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
  });
}
